import * as Yup from 'yup';
import { IDictionary } from '@constants/languages/types';
import { phoneExpression } from '@constants/regularExpression';

function locationsValidationSchema(dictionary: IDictionary) {
  return Yup.object({
    name: Yup.string()
      .required(dictionary.validation.locationName)
      .max(50, dictionary.validation.locationCharacters),
    number: Yup.string()
      .required(dictionary.validation.locationPhone)
      .min(12, dictionary.validation.invalidLocationPhone)
      .matches(phoneExpression, dictionary.validation.invalidLocationPhone),
    address: Yup.string()
      .required(dictionary.validation.locationAddress)
      .max(100, dictionary.validation.locationAddressCharacters),
    llph: Yup.number()
      .required(dictionary.validation.plphValue)
      .nullable()
      .min(1, dictionary.validation.plphtMin)
      .max(500, dictionary.validation.plphtMax),
    schedule: Yup.object({
      days: Yup.object().shape({
        friday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        monday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        saturday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        sunday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        thursday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        tuesday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
        wednesday: Yup.array().of(
          Yup.object().shape({
            from: Yup.string().required(dictionary.validation.indicateSlots),
            to: Yup.string().required(dictionary.validation.indicateSlots),
          }),
        ),
      }),
    }).notRequired(),
  });
}

export default locationsValidationSchema;
